import { newToolFilterOAuthMcp } from "../oauth.ts";

export const plaidMcpResolver = newToolFilterOAuthMcp({
  iconUrl: "https://plaid.com/assets/img/favicons/apple-touch-icon.png",
  url: "https://api.dashboard.plaid.com/mcp/mcp",
  label: "Plaid",
});
